import React, { useState } from "react";
import "./Calendar.css";

const Calendar = ({ selectedDate, onDateSelect, reportDates }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startingDayOfWeek = firstDay.getDay(); // 0 = Sunday

    const days = [];

    // Fill in previous month's trailing days
    for (let i = 0; i < startingDayOfWeek; i++) {
      const prevDate = new Date(year, month, -(startingDayOfWeek - 1 - i));
      days.push({ date: prevDate, isCurrentMonth: false });
    }

    // Current month days
    for (let day = 1; day <= lastDay.getDate(); day++) {
      days.push({ date: new Date(year, month, day), isCurrentMonth: true });
    }

    return days;
  };

  const hasReports = (date) => {
    if (!date || !reportDates) return false;
    return reportDates.some((r) => r.toDateString() === date.toDateString());
  };

  const isSelected = (date) => {
    if (!date || !selectedDate) return false;
    return date.toDateString() === selectedDate.toDateString();
  };

  const isToday = (date) => {
    return date.toDateString() === new Date().toDateString();
  };

  const prevMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));

  const nextMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));

  const monthYear = currentMonth.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  const days = getDaysInMonth(currentMonth);
  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];

  // Format selected date label
  const formatLabel = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  };

  const selectedReports = selectedDate
    ? (reportDates || []).filter((r) => r.toDateString() === selectedDate.toDateString())
    : [];

  return (
    <div className="calendar">
      {/* Header */}
      <div className="calendar-header">
        <button onClick={prevMonth} className="calendar-nav-button">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path
              d="M12.5 15L7.5 10L12.5 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <span className="calendar-month-year">{monthYear}</span>
        <button onClick={nextMonth} className="calendar-nav-button">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path
              d="M7.5 5L12.5 10L7.5 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Week day headers */}
      <div className="calendar-week-days">
        {weekDays.map((day, i) => (
          <div key={i} className="calendar-week-day">
            {day}
          </div>
        ))}
      </div>

      {/* Days grid */}
      <div className="calendar-days-grid">
        {days.map(({ date, isCurrentMonth }, index) => (
          <div key={index} className="calendar-day-cell">
            <button
              onClick={() => isCurrentMonth && onDateSelect(date)}
              className={[
                "calendar-day-button",
                !isCurrentMonth ? "other-month" : "",
                isSelected(date) ? "selected" : "",
                isToday(date) && !isSelected(date) ? "today" : "",
              ].join(" ")}
            >
              {date.getDate()}
              {hasReports(date) && !isSelected(date) && isCurrentMonth && (
                <span className="calendar-report-indicator" />
              )}
            </button>
          </div>
        ))}
      </div>

      {/* Divider + selected date info */}
      <div className="calendar-footer">
        <div className="calendar-footer-date">{formatLabel(selectedDate)}</div>
        <div className="calendar-footer-events">
          {selectedReports.length === 0
            ? "No events scheduled"
            : `${selectedReports.length} event${selectedReports.length > 1 ? "s" : ""} scheduled`}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
